// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "7908e4b-dirty",
    "hash": "7908e4b",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "7908e4b-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
